<template>
  <div class="header-page" :style="'background-image: url(' + matchInfo.background + ');'">
    <div class="info-warp">
      <div class="match-logo">
        <img :src="matchInfo.logo">
      </div>
      <div class="match-title">
        {{matchInfo.title||'未知'}}
      </div>
      <div class="match-info">
        <p><a-icon type="clock-circle" /><span>{{$t('开赛时间')}}：{{(matchInfo.beginTime||'').slice(0,10)}}</span></p>
        <p><a-icon type="environment" /><span>{{$t('赛事地址')}}：{{matchInfo.address||'未知'}}</span></p>
        <p><a-icon type="team" /><span>{{$t('赛事级别')}}：{{matchInfo.levelName||'未知'}}</span></p>
        <p v-if="matchInfo.annex"><a-icon type="file" /><a :href="matchInfo.annex" style="color:red;">{{$t('赛事附件')}}</a></p>
      </div>
      <div class="btn-warp">
        <button @click="applySubmit(matchInfo.status)" :style="{background: matchFun.statusColor(matchInfo.status), fontSize: '16px'}">{{ matchFun.statusText(matchInfo.status) }}</button>
        <button v-if="matchInfo.status === 3 && matchInfo.isPlayerRes === 1" @click="showData" :style="{background: matchFun.statusColor(2), fontSize: '16px'}">下载报名表</button>
        <button v-if="matchInfo.refereeHide === 'SHOW'" @click="refereeSubmit(matchInfo.status)" :style="{background: matchFun.statusColor(matchInfo.status), fontSize: '16px'}">裁判员报名</button>
      </div>
      <a-modal title="下载报名表" :maskClosable="false" :visible="visible" :width="700" :confirm-loading="false" :footer="null" @cancel="handleCancel">
        <template v-if="agencyList && agencyList.length > 0">
          <PayDownload :agencyId="agencyList[0].agencyId" :agencyName="agencyList[0].unitName" :teamId="agencyList[0].teamId"/>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import matchFun from '@comm/utils/matchFun'
import PayDownload from '@comm/components/join/joinFactory/PayDownload'
export default {
  components: {
    PayDownload
  },
  name: 'MatchInfo',
  created () {
    let info = store.getters['match/matchInfo']
    if (!info || info.matchId !== this.matchId || this.$route.path === '/MatchDetail' || this.isRefresh) {
      this.findData()
    } else {
      this.matchInfo = info
      document.title = this.matchInfo.title+'  '+document.title
      
    }
  },
  mounted () {
  },
  data () {
    return {
      visible: false,
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      isRefresh: Number(this.$route.query.isRefresh),
      matchFun: matchFun,
      matchInfo: {
        background: '',
        logo: '',
        title: '',
        beginTime: '',
        address: '',
        levelName: '',
        refereeHide: 'HIDE',
        heat: 0,
        status: 1
      },
      agencyList: []
    }
  },
  methods: {
    showData () {
      this.queryAgency()
    },
    handleCancel () {
      this.visible = false
    },
    queryAgency () {
      this.$api.join.agencyList().then(res => {
        if (res.status === 0) {
          this.agencyList = res.data
          if (this.agencyList.length > 0) {
            this.visible = true
          } else {
            this.$message.error('您未报名，无法下载')
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    findData () {
      this.$api.match.websiteMatchDetail({matchId: this.matchId}).then(res => {
        if (res.status === 0) {
          this.matchInfo = res.data
          this.matchInfo.matchId = this.matchId
          this.matchInfo.company = JSON.parse(this.matchInfo.company)
          this.matchInfo.imageIsRequired = JSON.parse(this.matchInfo.imageIsRequired)
          document.title = this.matchInfo.title+'  '+document.title
          store.commit('match/MATCH_CHANGE_MATCH_INFO', this.matchInfo)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    applySubmit (status) {
      if (status === 1) {
        this.$message.error('未开始报名')
        return
      }
      if (status === 3 || status === 4) {
        this.$message.error('报名已结束')
      } else if (status === 2) {
        if (this.matchInfo.grade === 'REFEREE') {
          let accessToken = store.getters['user/accessToken']
          if (accessToken === '') {
            store.commit('user/USER_CHANGE_IS_LOGIN', true)
          } else {
            this.$router.push({ path: '/Join', query: {matchId: this.matchId, programId: this.programId, step: 1} })
          }
        } else {
          this.$message.error('该比赛只能通过小程序报名！扫下方的小程序码，进入赛事小程序')
        }
      }
    },
    refereeSubmit (status) {
      let accessToken = store.getters['user/accessToken']
      if (accessToken === '') {
        store.commit('user/USER_CHANGE_IS_LOGIN', true)
      } else {
        this.$router.push({ path: '/Referee', query: {matchId: this.matchId, programId: this.programId, step: 1} })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-page{
  height:500px;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #000;
  background-size: 100% 500px;
  .info-warp{
    height: 500px;
    // padding: 23px 0;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    //background-color: rgba(0, 0, 0, 0.3);
    .match-logo{
      img{
        width: 120px;
        height: 120px;
        margin-bottom: 20px;
        border-radius: 50%;
      }
    }
    .match-title{
      padding: 10px 0;
      font-size: 30px;
    }
    .match-info{
      display: flex;
      flex-direction: row;
      font-size: 12px;
      p{
        // display: flex;
        padding: 5px 15px;
        align-items: center;
      }
      img{
        height: 16px;
        margin-right: 5px;
      }
    }
    .btn-warp{
      padding: 10px 0;
      button{
        cursor: pointer;
        padding: 5px 25px;
        color: #fff;
        border-radius: 4px;
        border: 0px;
        outline: none;
        box-shadow: rgba(0, 0, 0, 0.5) 1px 1px 3px 1px;
      }
    }
    .match-rule{
      font-size: 12px;
      line-height: 40px;
      color: #707070;
      a{
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchInfo.vue